import AttachmentResource from '@/api/resources/attachment/attachmentResource'
import { auth } from '@/api/auth'
import { BASE_URL } from '@/api/api'

class PortionAttachmentService extends AttachmentResource {
    async addAttachment(labId, caseId, sampleId, portionId, attachmentTypeId, file, thumbnailBytes) {
        let thumbnail

        if (thumbnailBytes) {
            thumbnail = this.base64ToBlob(thumbnailBytes, file.name)
        } else {
            let generatedThumbnailBytes = await this.thumbnailifyFromBlob(file)
            thumbnail = this.base64ToBlob(generatedThumbnailBytes, file.name)
        }

        const formData = new FormData()
        formData.append('file', file, file.name)
        formData.append('atyId', attachmentTypeId)

        if (thumbnail) {
            formData.append('thumbnail', thumbnail, file.name)
        }

        const response = await this.axios.post(
            `/common/laboratories/${labId}/cases/${caseId}/samples/${sampleId}/portions/${portionId}/attachments`,
            formData, { headers: { 'content-type': 'multipart/form-data' } })
        return response.data
    }

    async getAttachments(laboratoryId, caseId, sampleId, portionId, attachmentTypeId) {
        const params = { attachmentTypeId }
        const response = await this.axios.get(`/common/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/portions/${portionId}/attachments`, { params })
        return response.data
    }

    async patchAttachment(laboratoryId, caseId, sampleId, portionId, attachmentId, request) {
        const response = await this.axios.patch(`/common/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/portions/${portionId}/attachments/${attachmentId}`, request)
        return response.data
    }

    async getFile(laboratoryId, caseId, sampleId, portionId, attachmentId) {
        return this.axios.get(`/common/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/portions/${portionId}/attachments/${attachmentId}`, {
            headers: { 'content-type': 'multipart/form-data' },
            responseType: 'blob'
        }).then(response => response.data)
    }

    getUrlFile(laboratoryId, caseId, sampleId, portionId, attachmentId) {
        return `${BASE_URL}/common/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/portions/${portionId}/attachments/${attachmentId}?authenticationToken=${auth.token}`
    }

    async deleteAttachment(laboratoryId, caseId, sampleId, portionId, attachmentId) {
        const response = await this.axios.delete(`/common/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/portions/${portionId}/attachments/${attachmentId}`)
        return response.data
    }
}

export default new PortionAttachmentService()
